module.exports = __webpack_public_path__ + "static/media/business_n.b651a0a3.png";